import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrandProvider, ThemeProvider } from "@tricura/atlas-ui";
import { App } from "./App";
import { AuthProvider } from "./auth";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <BrandProvider defaultBrand="orion">
            <ThemeProvider defaultTheme="light">
                <AuthProvider>
                    <App />
                </AuthProvider>
            </ThemeProvider>
        </BrandProvider>
    </StrictMode>,
);
